import React from 'react';
import { FieldRenderer } from '../fieldRegistry';
import { TitleField } from './TitleField';

/** The kicker shown above a card's title. */
export const renderSubtitleField: FieldRenderer = (
  field,
  formState,
  updateFormState
) => (
  <TitleField
    key={field.name}
    id="card-subtitle"
    label="Helper tag"
    optional
    helperText={field.helperText}
    value={(formState[field.name] as string) || ''}
    onChange={(value: string) =>
      updateFormState(prev => ({ ...prev, [field.name]: value }))
    }
    maxLength={field.maxLength}
    placeholder={field.placeholder ?? ''}
  />
);
